import { styled, TextField } from '@mui/material';

export interface StyledTextFieldType {
  placeHolderColor: string;
  borderColor: string;
  borderRadius: string;
  fontFamily: string;
  fontColor: string;
  isItalic: boolean;
  height: string;
  borderWidth: string;
}

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => {
    return (
      prop !== 'placeHolderColor' &&
      prop !== 'borderColor' &&
      prop !== 'fontFamily' &&
      prop !== 'fontColor' &&
      prop !== 'isItalic' &&
      prop !== 'borderRadius' &&
      prop !== 'height' &&
      prop !== 'borderWidth'
    );
  },
})((prop: StyledTextFieldType) => ({
  input: {
    color: prop.placeHolderColor,
    '& .MuiInputBase-root': {},
    '&::placeholder': {
      fontStyle: prop.isItalic ? 'italic' : '',
    },
    padding: '8px 7px',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: prop.borderColor,
      borderRadius: prop.borderRadius,
      borderWidth: prop.borderWidth,
    },
  },
  '& .MuiInputBase-input': {
    padding: '0px 7px',
    fontFamily: prop.fontFamily,
    color: prop.fontColor,
    height: prop.height,
  },
}));
